export type ResizeObserverDimensions = {
    width: number
    height: number
}

const throttle = (f, delay) => {
    let timer: any = 0
    return function(...args) {
        clearTimeout(timer)
        timer = setTimeout(() => f.apply(this, args), delay)
    }
}

export const newResizeObserver = (rebuildChartCallback: () => void): ResizeObserver =>
    new ResizeObserver(
        throttle(entries => {
            if (entries.length !== 1) {
                throw new Error('only one entry expected')
            }

            rebuildChartCallback()
        }, 200),
    )
